export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const CLEAR_ERRORS_SUCCESS = 'CLEAR_ERRORS_SUCCESS';
export const EMAIL_VERIFICATION_SUCCESS = 'EMAIL_VERIFICATION_SUCCESS';
export const EMAIL_VERIFICATION_FAIL = 'EMAIL_VERIFICATION_FAIL';
export const SEND_CODE_SUCCESS = 'SEND_CODE_SUCCESS';
export const SEND_CODE_FAIL = 'SEND_CODE_FAIL';
export const GOOGLE_URL_FAIL = 'GOOGLE_URL_FAIL';
export const GOOGLE_SIGNIN_SUCCESS = 'GOOGLE_SIGNIN_SUCCESS';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const SIGNIN_FAIL = 'SIGNIN_FAIL';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL';
export const PASSWORD_UPDATE_SUCCESS = 'PASSWORD_UPDATE_SUCCESS';
export const PASSWORD_UPDATE_FAIL = 'PASSWORD_UPDATE_FAIL';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const IS_SUBMITTING = 'IS_SUBMITTING';
export const SET_COUNT = 'SET_COUNT';
export const RESET_COUNT = 'RESET_COUNT';